import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';


export const webinarApi = createApi({
  baseQuery,
  reducerPath: 'webinarApi',
  tagTypes: ['webinar'],
  endpoints: (builder) => ({
    // createWebinar: builder.mutation({
    //   query: (data) => ({
    //     url: '/counselor/webinar',
    //     method: 'POST',
    //     body: data,
    //   }),
    // }),
    // deleteWebinar: builder.mutation({
    //   query: ({ id, data }) => ({
    //     url: `/counselor/delete-webinar/${id}`,
    //     method: 'POST',
    //     body: data,
    //   }),
    // }),
    getWebinarList: builder.query({
      query: ({ page = 1, items = 10, filters }) => ({
        url: `/counselings/webinar/list?page=${page}&items=${items}`,
        method: 'POST',
        body: filters,
      }),
      keepUnusedDataFor: 0
    }),
    getWebinarDetails: builder.query({
      query: (id) => ({
        url: `/counselings/webinar/${id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0
    }),
    startWebinar: builder.mutation({
      query: (id) => ({
        url: `/counselings/start-webinar/${id}`,
        method: 'POST',
      }),
    }),
  }),

});

export const {
  // useCreateWebinarMutation,
  // useDeleteWebinarMutation,
  useGetWebinarListQuery,
  useGetWebinarDetailsQuery,
  useStartWebinarMutation
} = webinarApi;
